import { render } from "./EmailRecipientManager.vue?vue&type=template&id=2abab6a0"
import script from "./EmailRecipientManager.vue?vue&type=script&lang=js"
export * from "./EmailRecipientManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__